import { useEffect, useState } from "react";
import { Copy, Globe } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Panel, SectionLabel } from "@/components/common/ui-kit";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";

export const WebFormPanel = () => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/web-form").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return null;
  const url = `${window.location.origin}${d.path}`;
  const code = `<iframe src="${url}" title="Richiesta informazioni" style="width:100%;height:760px;border:0" loading="lazy"></iframe>`;
  const copy = () => navigator.clipboard.writeText(code).then(() => toast.success("Codice copiato")).catch(() => toast.error("Copia non riuscita: seleziona il testo e copialo a mano."));
  return (
    <Panel className="p-5 lg:col-span-3" data-testid="webform-panel">
      <div className="mb-2 flex items-center gap-2"><Globe className="h-4 w-4 text-slate-400" /><SectionLabel>Modulo richieste dal sito web</SectionLabel></div>
      <p className="mb-3 text-xs text-slate-500">Incolla questo codice nella pagina «Contatti» del sito. Ogni richiesta crea un cliente da qualificare (o usa quello esistente con la stessa email/azienda) e un'opportunità nella prima fase della pipeline, assegnata a {d.owner || "—"}. Notifica nel CRM a: {d.notified.join(", ") || "—"}. Per il link all'informativa aggiungi <code>?privacy=URL</code> all'indirizzo. Richieste ricevute finora: {d.total}.</p>
      <Textarea readOnly rows={3} value={code} className="font-mono text-xs" data-testid="webform-embed-code" />
      <div className="mt-3 flex flex-wrap gap-2">
        <Button onClick={copy} data-testid="webform-copy"><Copy className="mr-2 h-4 w-4" />Copia codice</Button>
        <Button variant="outline" asChild><a href={url} target="_blank" rel="noreferrer" data-testid="webform-preview">Apri anteprima</a></Button>
      </div>
    </Panel>
  );
};
